export const homeObjOne2 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Prestige Event & Catering ',
    headline: 'Lokaler för alla tillfällen',
    description: 'På Prestige Event & Catering erbjuder vi ett brett utbud av unika och flexibla evenemangslokaler som kan anpassas efter just era behov. Oavsett om ni planerar en mindre workshop, en middag i intim miljö, en konferens eller en storslagen gala finns det en lokal som passar ert arrangemang.',
    imgStart: false,
    img: require('../../AssetsForEvent/de-kroon.jpeg'),
    alt: 'catering',
    dark: true,
    primary: true,
    darkText: false,
}